import { logout } from '../../auth.service';
import Login from '../../../pages/Login';

const FranquiaA = () =>
{    
    localStorage.setItem("tenantId", "franquiaa");
    localStorage.setItem("logoVertical", "logoSampleclient");
    logout();
    
    return Login();
};

export default FranquiaA;